import { render, staticRenderFns } from "./OrderReceipt.vue?vue&type=template&id=fc4148c2&scoped=true"
import script from "./OrderReceipt.vue?vue&type=script&lang=js"
export * from "./OrderReceipt.vue?vue&type=script&lang=js"
import style0 from "./OrderReceipt.vue?vue&type=style&index=0&id=fc4148c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4148c2",
  null
  
)

export default component.exports